import React from "react"
import { Heading } from "@aws-amplify/ui-react"

const SignInHeader = () => (
  <Heading level={3}>Sign in to Merchant Portal</Heading>
)

export default SignInHeader
